module.exports = __webpack_public_path__ + "media/images/ic_cast_black_24dp-3457484d.png";